<template>
  <div class="validation-box">
    <slot/>
    <div class="validation"
         :class="{'deliveryDay':(type=='deliveryDay'),
                  'purchaseOrder':(type=='purchaseOrder'),
                  'packagings':(type==='packagings'),
                  'units':(type==='units'),
                  'total':(type==='total')}">
      <span class="text">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.validation-box {
  position: relative;
  display: inline-block;
}

.validation {
  font-size: 9pt;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  padding: 5px 0;
  border-radius: 2px;
  width: 80px;
  bottom: 100%;
  left: 50%;
  margin-bottom: -7px;
  transition: opacity 1s;
  position: absolute;
  z-index: 2;
  background: red;
}

.validation::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 6px;
  border-style: solid;
  border-color: transparent red transparent transparent;
}

.deliveryDay {
  margin-left: 5px;
}

.purchaseOrder {
  margin-left: 180px;
}

.packagings {
  margin-left: 60px;
}

.units {
  margin-left: -85px;
}

.units::after {
  left: 100%;
  border-color: transparent transparent transparent red;
}

.total {
  margin-left: -385px;
}

.total::after {
  left: 100%;
  border-color: transparent transparent transparent red;
}


</style>
